var _path;
var _excluded = ["title", "titleId", "desc", "descId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgLines = function SvgLines(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    desc = _ref.desc,
    descId = _ref.descId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    fill: "none",
    viewBox: "0 0 27 27",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  }, props), desc ? /*#__PURE__*/React.createElement("desc", {
    id: descId
  }, desc) : null, title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M.495 17.477a1.04 1.04 0 0 0 1.433-.318l6.349-9.977 1.764 3.026L.184 25.374a1.037 1.037 0 1 0 1.738 1.13l9.291-14.29 3.469 5.944c.182.316.516.512.88.519h.016c.358 0 .69-.184.88-.488l2.31-3.695 2.14 3.664c.195.31.53.503.896.519.37-.001.711-.199.896-.52l4.15-7.262a1.037 1.037 0 1 0-1.8-1.029l-3.256 5.698-1.783-3.058 6.823-10.917A1.04 1.04 0 1 0 25.07.49L18.83 10.48l-3.392-5.81c-.18-.313-.51-.51-.872-.519a1.01 1.01 0 0 0-.894.472l-2.364 3.631L9.211 4.67a1.04 1.04 0 0 0-.875-.519c-.36.005-.694.184-.897.48L.176 16.045a1.04 1.04 0 0 0 .319 1.433m13.998-10.31 3.093 5.301-1.978 3.165-3.13-5.367z"
  })));
};
export default SvgLines;